interface PencilIconProps {
  /** Solid pencil (annotation drawn) vs hollow outline (drawable, not drawn). */
  filled?: boolean;
  className?: string;
}

// One pencil silhouette, rendered either solid or hollow so the two row states
// contrast strongly — stock filled/outline pencils read nearly identical at this
// size. Custom SVG (no baseline stroke, unlike antd's Edit icon). Colours come
// from `currentColor`, so the caller's text colour drives fill/stroke.
const PENCIL_PATH =
  'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z';

export function PencilIcon({ filled = false, className }: PencilIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d={PENCIL_PATH}
        fill={filled ? 'currentColor' : 'none'}
        stroke={filled ? 'none' : 'currentColor'}
        strokeWidth={filled ? 0 : 2}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
